module.exports = __webpack_public_path__ + "img/logo_title.3235bda8.png";